var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogowhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 708.66 213.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M670.53,73.51v-21.65c0-21.53-17.45-38.98-38.98-38.98h-111.64c-21.53,0-38.98,17.45-38.98,38.98v111.64c0,21.53,17.45,38.98,38.98,38.98h111.64c21.53,0,38.98-17.45,38.98-38.98v-29.96c0-1.67-2.02-2.51-3.2-1.33l-11.69,11.7c-.35.35-.55.83-.55,1.33v18.26c0,13-10.54,23.53-23.53,23.53h-111.64c-13,0-23.53-10.54-23.53-23.53V51.87c0-13,10.54-23.53,23.53-23.53h111.64c13,0,23.53,10.54,23.53,23.53v33.32c0,1.67,2.02,2.51,3.2,1.33l11.69-11.67c.35-.35.55-.83.55-1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M616.38,62.16h-93.96c-4.27,0-7.72-3.46-7.72-7.72s3.46-7.72,7.72-7.72h93.96c4.27,0,7.72,3.46,7.72,7.72s-3.46,7.72-7.72,7.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M589.9,98.95h-67.48c-4.27,0-7.72-3.46-7.72-7.72s3.46-7.72,7.72-7.72h67.48c4.27,0,7.72,3.46,7.72,7.72s-3.46,7.72-7.72,7.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M563.42,135.73h-41c-4.27,0-7.72-3.46-7.72-7.72s3.46-7.72,7.72-7.72h41c4.27,0,7.72,3.46,7.72,7.72s-3.46,7.72-7.72,7.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M691.88,90.72l-21.36,21.36-15.45,15.45-31.36,31.37c-1.5,1.46-3.43,2.22-5.36,2.22-1.55,0-3.11-.49-4.46-1.5l-26.39-26.38c-.95-.95-1.74-2.04-2.23-3.28-.18-.44-.3-.87-.36-1.23-.06-.49-.06-1.68,0-2.18.51-3.87,4.01-6.25,7.53-6.25,1.92,0,3.83.7,5.28,2.25l20.72,20.72,36.63-36.61,5.2-5.2,10.24-10.22,1.11-1.1,9.66-9.66c.87-.87,1.89-1.6,3.05-2.01.81-.28,1.62-.41,2.41-.41,5.8,0,10.14,7.25,5.14,12.68Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "224.97 168.24 188.46 114.4 188.29 114.15 180.79 114.15 180.79 202.49 188.56 202.49 188.56 129.1 223.04 180.32 226.77 180.32 261.25 129.1 261.25 202.49 269.01 202.49 269.01 114.15 261.52 114.15 224.97 168.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M306.71,114.15l-32.65,87.55-.29.79h8.34l9.09-24.41h38.92l9.09,24.41h8.34l-32.94-88.34h-7.91ZM327.2,170.19h-33.06l16.59-44.2,16.47,44.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "336.06 122.04 359.85 122.04 359.85 202.49 367.62 202.49 367.62 122.04 391.53 122.04 391.53 114.15 336.06 114.15 336.06 122.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "447.11 122.04 447.11 114.15 397.87 114.15 397.87 202.49 447.11 202.49 447.11 194.72 405.64 194.72 405.64 160.64 443.12 160.64 443.12 152.88 405.64 152.88 405.64 122.04 447.11 122.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.26,74.01l13.45,8.89c-7.56,9.61-19.33,15.61-33.38,15.61-24.86,0-42.75-18.97-42.75-43.59S32.47,11.44,57.33,11.44c14.05,0,25.82,5.89,33.38,15.61l-13.45,8.89c-4.44-5.4-11.17-9.01-19.93-9.01-17.41,0-26.42,14.05-26.42,27.98s9.01,28.1,26.42,28.1c8.77,0,15.49-3.6,19.93-9.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.21,54.91c0,24.62-17.89,43.59-42.75,43.59s-42.75-18.97-42.75-43.59,17.89-43.47,42.75-43.47,42.75,18.85,42.75,43.47ZM159.88,54.91c0-13.93-9.01-27.98-26.42-27.98s-26.42,14.05-26.42,27.98,9.01,28.1,26.42,28.1,26.42-14.05,26.42-28.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M269.05,12.89v84.05h-16.33v-55.72l-25.1,40.71h-5.4l-25.22-40.71v55.72h-16.21V12.89h17.29l26.78,43.23,26.78-43.23h17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.7,41.94c0,17.41-12.25,28.94-32.3,28.94h-11.77v26.06h-16.33V12.89h28.1c20.05,0,32.3,11.65,32.3,29.06ZM319.13,41.94c0-8.89-5.76-13.93-15.73-13.93h-11.77v27.74h11.77c9.97,0,15.73-5.04,15.73-13.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M391.53,81.81v15.13h-48.63V12.89h16.21v68.92h32.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "431.02 28.02 431.02 81.82 447.1 81.82 447.1 96.94 398.73 96.94 398.73 81.82 414.82 81.82 414.82 28.02 398.73 28.02 398.73 12.89 447.1 12.89 447.1 28.02 431.02 28.02"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogowhite);
export default __webpack_public_path__ + "static/media/logowhite.7ddc6953c4d0ee0db28ca76c3291d3f6.svg";
export { ForwardRef as ReactComponent };